import Vue from 'vue' //引入Vue
import Router from 'vue-router' //引入vue-router
Vue.use(Router)

import appMain  from '../view/pages/appMain.vue'
//Vue全局使用Router
const originalPush = Router.prototype.push
Router.prototype.push =function push(location){
  return originalPush.call(this,location).catch(err =>err)
}
export default new Router({
  mode:"history",
  // eslint-disable-next-line no-unused-vars
  scrollBehavior(to, from, savedPosition) {
    // return 期望滚动到哪个的位置
    return {
      x: 0,
      y: 0
    }
  },

  routes: [ //配置路由，这里是个数组
    { //每一个链接都是一个对象
      path: '/', //链接路径
      redirect: '/index',
      component: appMain,
      children:[
       
        {
          path: '/index',
          name: 'index',
          component: () => import('@/view/pages/index.vue'),
        },
        {
          path: '/games',
          name: 'games',
          component: () => import('@/view/pages/games.vue'),
        }, 
        {
          path: '/serviceAgreement',
          name: 'serviceAgreement',
          component: () => import('@/view/info/serviceAgreement.vue'),
        },
        {
          path: '/privacypolicy',
          name: 'privacypolicy',
          component: () => import('@/view/info/privacypolicy.vue'),
        },
        {
          path: '/aboutus',
          name: 'aboutus',
          component: () => import('@/view/info/aboutus.vue'),
        },
       
        {
          path: '/terms',
          name: 'terms',
          component: () => import('@/view/info/terms.vue'),
        },
        {
          path: '/contactus',
          name: 'contact',
          component: () => import('@/view/info/contactus.vue'),
        },
        // {
        //   path: '/join',
        //   name: 'join',
        //   component: () => import('@/view/info/join.vue'),
        // },
         {
          path: '/payment',
          name: 'payment',
          component: () => import('@/view/pages/payment.vue'),
        },
      ]
    },
    
   
   
  ]
})

